import { Text } from 'components/v2/Typography/Text';
import theme from 'kb-shared/theme';
import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(39, 42, 94, 0.32);
  z-index: ${({ theme }) => theme.layers.footer + 1};
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (orientation: landscape) {
    padding: 16px;
  }
`;

export const Categories = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const Category = styled.li`
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  border-radius: 8px;
  background: #fff;
  box-shadow:
    0px 0px 0px 1px rgba(18, 18, 18, 0.1),
    0px 1px 1px 0px rgba(18, 18, 18, 0.1);
  display: grid;
  grid-template-columns: 48px 1fr;
  grid-template-rows: 25px;
  grid-template-areas:
    'icon name'
    'icon description';
  column-gap: 16px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutral.lavenderLight};
  }
`;

export const Icon = styled.div`
  grid-area: icon;
  align-self: center;
`;

export const CategoryName = styled(Text).attrs({ size: 'md', fontStyle: 'bold' })`
  grid-area: name;
  margin-right: 8px;
`;

export const CategoryDescription = styled(Text).attrs({
  size: 'sm',
  fontStyle: 'regular',
  color: theme.colors.neutral.lightNavy
})`
  grid-area: description;
`;
